import { inject } from 'vue'
import { RequestService } from './RequestService'

/**
 * Access catalog read/write (platform admin).
 */
export function AccessCatalogService() {
  const functionsBaseUrl = inject('functionsBaseUrl')
  const { simpleGet, put, del, handleErrors } = RequestService()

  const base = `${functionsBaseUrl}/accessGateway/api/v1/access/catalog`

  async function getCatalog() {
    try {
      const response = await simpleGet('getAccessCatalog', base)
      if (response?.data?.success) {
        return response.data.data
      }
      throw new Error(response?.data?.message || 'Failed to load access catalog')
    } catch (error) {
      handleErrors('AccessCatalogService.getCatalog', error)
      throw error
    }
  }

  async function savePermission(key, body) {
    const response = await put('saveCatalogPermission', `${base}/permissions/${encodeURIComponent(key)}`, body)
    if (!response?.data?.success) {
      throw new Error(response?.data?.message || 'Failed to save permission')
    }
    return response.data.data
  }

  async function saveModule(key, body) {
    const response = await put('saveCatalogModule', `${base}/modules/${encodeURIComponent(key)}`, body)
    if (!response?.data?.success) {
      throw new Error(response?.data?.message || 'Failed to save module')
    }
    return response.data.data
  }

  async function saveRole(key, body) {
    const response = await put('saveCatalogRole', `${base}/roles/${encodeURIComponent(key)}`, body)
    if (!response?.data?.success) {
      throw new Error(response?.data?.message || 'Failed to save role')
    }
    return response.data.data
  }

  async function deactivate(type, key) {
    const response = await del('deactivateCatalogEntry', `${base}/${type}/${encodeURIComponent(key)}`)
    if (!response?.data?.success) {
      throw new Error(response?.data?.message || 'Failed to deactivate catalog entry')
    }
    return response.data.data
  }

  return {
    getCatalog,
    savePermission,
    saveModule,
    saveRole,
    deactivate
  }
}
